import React from 'react';
import TeamBadge, { pickTeamLogo } from './TeamBadge';
import { matchStatusConfig, parseScorePair } from './matchWidgetUtils';

export default function MatchScoreHero({ match, competitionLabel = '', compact = false }) {
  const status = matchStatusConfig(match);
  const isUpcoming = status.key === 'upcoming';
  const { home: homeScore, away: awayScore } = parseScorePair(match.score);
  const showNumericScore = !isUpcoming && homeScore != null && awayScore != null;

  const subtitle = isUpcoming
    ? match.kickoff || match.minute || match.score
    : match.minute || (status.key === 'finished' ? 'FT' : '—');

  return (
    <div className={`sw-match-hero sw-match-hero--${status.key} ${compact ? 'sw-match-hero--compact' : ''}`}>
      <div className="sw-match-hero__glow" aria-hidden />

      <div className="relative z-[1] px-4 pt-4 pb-3">
        <div className="flex items-center justify-between mb-4">
          <span className={`sw-status-badge ${status.className}`}>
            {status.pulse && <span className="sw-status-badge__dot" aria-hidden />}
            {status.label}
          </span>
          <span className="text-xs font-mono font-semibold tabular-nums" style={{ color: 'var(--sw-muted)' }}>
            {subtitle}
          </span>
        </div>

        <div className="sw-scoreboard">
          <div className="sw-scoreboard__team">
            <TeamBadge
              name={match.home}
              logoUrl={pickTeamLogo(match, 'home')}
              size={compact ? 44 : 56}
            />
            <p className="sw-scoreboard__name">{match.home}</p>
          </div>

          <div className="sw-scoreboard__center">
            {showNumericScore ? (
              <span className="sw-scoreboard__score tabular-nums">
                {homeScore}
                <span className="sw-scoreboard__sep">:</span>
                {awayScore}
              </span>
            ) : (
              <span className="sw-scoreboard__vs">{isUpcoming ? 'VS' : match.score || '—'}</span>
            )}
            {match.ht?.label && (
              <span className="sw-scoreboard__meta">HT {match.ht.label}</span>
            )}
            {match.et?.label && <span className="sw-scoreboard__meta">ET {match.et.label}</span>}
            {match.penalties?.label && (
              <span className="sw-scoreboard__meta">Pens {match.penalties.label}</span>
            )}
          </div>

          <div className="sw-scoreboard__team">
            <TeamBadge
              name={match.away}
              logoUrl={pickTeamLogo(match, 'away')}
              size={compact ? 44 : 56}
            />
            <p className="sw-scoreboard__name">{match.away}</p>
          </div>
        </div>

        {competitionLabel && !compact && (
          <p className="text-center text-[10px] font-bold uppercase tracking-widest mt-3" style={{ color: 'var(--sw-muted)' }}>
            {competitionLabel}
          </p>
        )}
      </div>
    </div>
  );
}
